<template>
  <div class="change-payment-system-popup">
    <p class="change-payment-system-popup__title">
      😣
      <br>
      Uh-oh! It seems there was a hiccup with your payment
    </p>

    <p class="change-payment-system-popup__text">
      Give it another shot or switch to a different payment provider to proceed with your transaction
    </p>

    <div class="change-payment-system-popup__buttons">
      <button
        class="button button-dark-additional change-payment-system-popup__button"
        @click="proceed(data.orderId, PaymentSystemModel.ECOMMPAY.id)">
        Try Again
      </button>

      <button
        class="button button-main change-payment-system-popup__button"
        @click="proceed(data.orderId, PaymentSystemModel.STRIPE.id)">
        Try Different Method
      </button>
    </div>
  </div>
</template>

<script>
import PaymentSystemModel from 'Models/PaymentSystemModel';
import paymentProceedMixin from 'Root/mixins/paymentProceedMixin';

export default {
  name: 'ChangePaymentSystemPopup',

  mixins: [paymentProceedMixin],

  props: {
    /**
     * {
     *   orderId: string,
     * }
     */
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      orderId: null,
      PaymentSystemModel,
    };
  },
};
</script>

<style lang="scss">
  .change-payment-system-popup .mobile-panel-popup__body {
    padding: 0;
  }

  .change-payment-system-popup.mobile-panel-popup {
    background-color: $color--basic-black;
  }

  @media screen and #{$screen-more-or-640} {
    .change-payment-system-popup > .vuedal {
      width: auto !important;
    }
  }
</style>

<style scoped lang="scss">
  .change-payment-system-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 440px;
    padding: 16px 48px 48px;
    border-radius: 15px;
  }

  .change-payment-system-popup__title {
    font-size: 25px;
    line-height: 29px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 24px;
    color: $color--basic-white;
  }

  .change-payment-system-popup__text {
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    margin-bottom: 24px;
    color: $color--basic-white;
    font-weight: 400;
  }

  .change-payment-system-popup__buttons {
    display: flex;
  }

  .change-payment-system-popup__button {
    width: max-content;
    padding: 15px;
    font-size: 15px;

    &:first-child {
      margin-right: 16px;
    }
  }

  @media screen and #{$screen-less-than-640} {
    .change-payment-system-popup {
      width: 100%;
      padding: 16px 24px 40px;
    }

    .change-payment-system-popup__title {
      max-width: 270px;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 16px;
    }

    .change-payment-system-popup__text {
      max-width: 270px;
      font-size: 13px;
      line-height: 18px;
      margin-bottom: 16px;
    }

    .change-payment-system-popup__buttons {
      flex-direction: column;
      width: 100%;
    }

    .change-payment-system-popup__button {
      width: 100%;
      padding: 12px;
      font-size: 13px;

      &:first-child {
        margin-right: 0;
        margin-bottom: 16px;
      }
    }
  }
</style>
